var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "inIcon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 462",
    transform: "translate(.083)",
    fill: "#a1a1a1",
    stroke: "#707070",
    d: "M0 0h72v72H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "inIcon_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 461",
    fill: "none",
    d: "M0 0h72v72H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.083)",
    clipPath: "url(#inIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "InIcon",
    transform: "translate(.083)",
    clipPath: "url(#inIcon_svg__b)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 418"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 738",
    d: "M5.909 47.384V27.436h8.664v-2.868h3.481v2.868h8.765V44.97q0 1.649-.813 2.081a9.524 9.524 0 01-3.532.381q-.686 0-3-.051l-.991-3.527q.661 0 2.566.1h.559a4.449 4.449 0 001.55-.152.58.58 0 00.254-.482V30.532h-5.587q-.1 1.168-.305 2.284a39.184 39.184 0 013.354 3.02 23.238 23.238 0 012.413 2.893l-2.49 3.2a27.574 27.574 0 00-4.293-5.845 14.1 14.1 0 01-2.388 3.451 12.514 12.514 0 01-2.617 2.208l-2.007-2.859a10.171 10.171 0 003.251-3.277 14.339 14.339 0 001.6-5.076h-5.03v16.853z",
    fill: "#231815"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 739",
    d: "M42.578 52.844h20.245a3 3 0 100-6H42.578a7.513 7.513 0 01-7.508-7.5v-.906a7.512 7.512 0 017.508-7.5h15.84a3 3 0 100-6h-15.84a13.522 13.522 0 00-13.515 13.5v.906a13.523 13.523 0 0013.515 13.5",
    fill: "#040000"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 740",
    d: "M62.989 30.938a3 3 0 001.932-5.3L51.839 14.68a3.002 3.002 0 10-3.86 4.6L61.06 30.24a2.994 2.994 0 001.929.7",
    fill: "#040000"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 741",
    d: "M49.906 41.898a2.992 2.992 0 001.929-.7l13.081-10.96a3.002 3.002 0 10-3.86-4.6L47.979 36.6a3 3 0 001.927 5.298",
    fill: "#040000"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInIcon);
export default __webpack_public_path__ + "static/media/inIcon.e368d592bf273680.svg";
export { ForwardRef as ReactComponent };